import { createContext, useContext } from "react"
import type { ElementRegistry } from "./element-registry"
import type { IslandRegistry } from "./island-registry"
import type { CogoBlockDef } from "./types"
import type { DesignTokens } from "../runtime/design-tokens"

export interface RenderContextValue {
  registry: ElementRegistry
  resolveSymbol: (expr: string) => unknown
  dispatchEvent: (elementId: string, eventType: string, payload?: unknown) => void
  /** Direct programmatic navigation (e.g., from auto-generated sidebar nav) */
  navigate?: (route: string) => void
  mode: "preview" | "edit"
  blocks?: Record<string, CogoBlockDef>
  itemContext?: Record<string, unknown>
  designTokens?: DesignTokens
  /** Optional host-declared map of `type: "island"` names → React components.
   * When absent, the `IslandRenderer` warns and renders null — so apps that
   * don't use islands incur no runtime change. */
  islands?: IslandRegistry
}

export const RenderContext = createContext<RenderContextValue | null>(null)

export function useRenderContext(): RenderContextValue {
  const ctx = useContext(RenderContext)
  if (!ctx) throw new Error("RenderContext.Provider is missing")
  return ctx
}
